import React from 'react'
import { useConfirmDialog, useMutation } from '@ztechapps/common.hook'
import { queries } from './graphql'
import { BusyButtonLink } from '@ztechapps/webui.button'

export const DeleteContextMenuItem = ({ templateId }) => {
  const { confirm } = useConfirmDialog({
    text: `Are you sure you remove this item?`,
    title: 'Remove template?',
    buttons: { confirm: { text: 'Yes, remove it!' } },
  })

  const [onDelete] = useMutation({
    query: queries.deleteConfig.query,
    options: { mutationOptions: { refetchQueries: ['singleTemplate', 'allTemplate'] } },
  })

  const onClick = async (e) => {
    e?.preventDefault()

    await confirm(() => onDelete({ filter: { _id: templateId } }))
  }

  return <BusyButtonLink onClick={onClick} icon="trash" title="Delete this template?" className="text-danger" />
}
